var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("Facebook icon")]),
      _vm._v(" "),
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points:
              "0.001171875 0.00078125 20 0.00078125 20 19.8785156 0.001171875 19.8785156"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Archive",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c("g", { attrs: { id: "f_logo_RGB-Black_1024" } }, [
            _c("g", { attrs: { id: "Group-3" } }, [
              _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                _c("use", { attrs: { "xlink:href": "#path-1" } })
              ]),
              _vm._v(" "),
              _c("g", { attrs: { id: "Clip-2" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M20,10 C20,4.47714844 15.5228516,0 10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785156 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042969,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925781,12.890625 L11.5625,12.890625 L11.5625,19.8785156 C16.3431445,19.1283203 20,14.9912891 20,10",
                  id: "Fill-1",
                  fill: "#0A0B09",
                  mask: "url(#mask-2)"
                }
              })
            ]),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M13.8925781,12.890625 L14.3359375,10 L11.5625,10 L11.5625,8.12416016 C11.5625,7.33333984 11.9499023,6.5625 13.1921484,6.5625 L14.453125,6.5625 L14.453125,4.1015625 C14.453125,4.1015625 13.3087305,3.90625 12.2146484,3.90625 C9.93042969,3.90625 8.4375,5.290625 8.4375,7.796875 L8.4375,10 L5.8984375,10 L5.8984375,12.890625 L8.4375,12.890625 L8.4375,19.8785156 C8.94662109,19.9583984 9.4684375,20 10,20 C10.5315625,20 11.0533789,19.9583984 11.5625,19.8785156 L11.5625,12.890625 L13.8925781,12.890625",
                id: "Fill-4",
                fill: "#FFFFFE"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51aaaa48", { render: render, staticRenderFns: staticRenderFns })
  }
}